import { NgbModal , NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Injectable , ViewEncapsulation } from '@angular/core';
import { WebService } from '../web/web.service'
import { AlertdialogComponent } from '../../alertdialog/alertdialog.component'
@Injectable()
export class DialogService {
	//private activeModal: NgbActiveModal;
	//private modalRef: NgbModalRef;
  constructor(private modalService: NgbModal,private httpService:WebService) { }

  openAlert(message){
  	return new Promise((resolve, reject) => {
	    const modalRef = this.modalService.open(AlertdialogComponent);
	  	modalRef.componentInstance.message = message;
	  	modalRef.result.then(res=>{
	  		if(res){
	  			resolve(res);
	  		}else{
	  			resolve("no error");
	  		}
	  	});
  	});
  }

  



}


// WEBPACK FOOTER //
// ./src/app/services/dialog/dialog.service.ts